document.addEventListener('DOMContentLoaded', function () {
  const searchForms = document.querySelectorAll('form[action="/search"]');
  
  if (searchForms.length === 0) {
    return; // Aucun formulaire de recherche, on quitte direct
  }

  function simplifyString(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
  }

  searchForms.forEach(form => {
    form.addEventListener('submit', function (e) {
      const searchInput = form.querySelector('input[name="q"]');
      if (searchInput) {
        const searchTerm = searchInput.value.trim();
        if (searchTerm.length > 0) {
          e.preventDefault();
          fetch(`/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=collection&resources[limit]=5`)
            .then(response => response.json())
            .then(data => {
              const collections = data.resources.results.collections;
              const simplifiedSearch = simplifyString(searchTerm);

              const exactMatch = collections.find(col =>
                simplifyString(col.title) === simplifiedSearch ||
                simplifyString(col.handle) === simplifiedSearch
              );

              if (exactMatch) {
                window.location.href = exactMatch.url;
              } else {
                window.location.href = `/search?q=${encodeURIComponent(searchTerm)}`;
              }
            })
            .catch(() => {
              window.location.href = `/search?q=${encodeURIComponent(searchTerm)}`;
            });
        }
      }
    });
  });
});
